import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import { useRoutes } from '../hooks/useRoutes';
import { PlayMenuSheet, type PlayMenuItem } from './PlayMenuSheet';

const IconLeaderboard = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="6" height="12" rx="1"/>
    <rect x="2" y="13" width="6" height="8" rx="1"/>
    <rect x="16" y="5" width="6" height="16" rx="1"/>
  </svg>
);
const IconFriends = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="4"/><path d="M2 21c0-3.9 3.1-7 7-7s7 3.1 7 7"/>
    <circle cx="17" cy="6" r="3"/><path d="M22 17c0-2.8-2.2-5-5-5"/>
  </svg>
);
const IconTournaments = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z"/>
    <path d="M5 4H3v3a3 3 0 0 0 4 3"/><path d="M19 4h2v3a3 3 0 0 1-4 3"/>
  </svg>
);
const IconReferral = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="7" r="4"/>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <path d="M22 11h-6m3-3v6"/>
  </svg>
);
const IconGlobe = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z"/>
  </svg>
);

/**
 * Header'daki Topluluk (kupa) ikonundan açılan alttan sheet.
 * Liderlik maddesi iç içe ikinci bir sheet (Global / Arkadaşlar / Sezon) açar.
 */
export function CommunitySheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const { r } = useRoutes();
  const { t } = useI18n();
  const c = (t as any).community ?? {};
  const lb = (t as any).profile ?? {};
  const [lbOpen, setLbOpen] = useState(false);

  const communityItems: PlayMenuItem[] = [
    { key: 'leaderboard', title: c.leaderboard ?? 'Liderlik Tablosu', desc: c.leaderboardDesc ?? '', icon: IconLeaderboard,  accent: '#C9A66B', onClick: () => setLbOpen(true) },
    { key: 'friends',     title: c.friends ?? 'Arkadaşlar',           desc: c.friendsDesc ?? '',     icon: IconFriends,      accent: '#9CB4D1', onClick: () => navigate('/friends') },
    // Turnuvalar menüden gizli — otomatik/aktif turnuva üretimi yok, kullanıcı boş ekran görüyordu.
    // Bkz. memory: project_iap_rewarded_ads_backlog.md komşusu (turnuva backlog notu).
    { key: 'referral',    title: c.referral ?? 'Davet Et',            desc: c.referralDesc ?? '',    icon: IconReferral,     accent: '#A8C2A6', onClick: () => navigate('/referral') },
  ];

  const lbItems: PlayMenuItem[] = [
    { key: 'global',  title: lb.lbScopeGlobal ?? 'Global',      desc: c.leaderboardGlobalDesc ?? '',  icon: IconGlobe,        accent: '#C9A66B', onClick: () => navigate(`${r('leaderboard')}?scope=global`) },
    { key: 'friends', title: lb.lbScopeFriends ?? 'Arkadaşlar', desc: c.leaderboardFriendsDesc ?? '', icon: IconFriends,      accent: '#9CB4D1', onClick: () => navigate(`${r('leaderboard')}?scope=friends`) },
    { key: 'season',  title: c.leaderboardSeason ?? 'Sezon',    desc: c.leaderboardSeasonDesc ?? '',  icon: IconTournaments,  accent: '#C77B6E', onClick: () => navigate('/sezon-odulleri') },
  ];

  return (
    <>
      <PlayMenuSheet
        open={open}
        title={c.title ?? 'Topluluk'}
        closeLabel={t.home.menuClose}
        items={communityItems}
        variant="leaderboard"
        onClose={onClose}
      />
      <PlayMenuSheet
        open={lbOpen}
        title={c.leaderboard ?? 'Liderlik Tablosu'}
        closeLabel={t.home.menuClose}
        items={lbItems}
        variant="leaderboard"
        onClose={() => setLbOpen(false)}
      />
    </>
  );
}
